import React from 'react';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

interface StyledRadioProps extends RadioProps{

};


const useStyles = makeStyles(() => ({
    icon: {
        borderRadius: "50%",
        border: "1px solid black",
        width: 16,
        height: 16,
        "input:hover ~ &": {
            backgroundColor: "#ebf1f5",
        },
        "input:disabled ~ &": {
            boxShadow: "none",
            background: "rgba(206,217,224,.5)",
        },
    },
    checkedIcon: {
        backgroundColor: "#FFF",
        backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
        "&:before": {
            display: "block",
            width: 16,
            height: 16,
            backgroundImage: "radial-gradient(#000,#000 45%,transparent 20%)",
            content: '""',
        },
    }
}));

const StyledRadio: React.FC<StyledRadioProps> = (props) => {
    const classes = useStyles();
    return (
        <Radio
        icon={<span className={classes.icon} />}
        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
        style={{ color: "black" }}
        {...props} />
    );
}

export default StyledRadio;